import React from 'react'
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Grid2 as Grid,
  Box,
  Badge,
  useTheme,
  CardActionArea,
} from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'
import MedunitedBadge from '../assets/icons/MedunitedBadge.svg'

const styles = (theme: any) => ({
  card: {
    background: theme.palette.primary.light,
    borderRadius: '12px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(2),
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
    // maxWidth: 400,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    position: 'absolute',
  },
  avatar: {
    width: 100,
    height: 100,
    border: `2px solid ${theme.palette.grey[300]}`,
  },
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: 'green',
      color: 'green',
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    },
  },
  name: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
    marginTop: theme.spacing(1),
  },
  contact: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    color: theme.palette.grey[600],
  },
  detailBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0.6),
    backgroundColor: theme.palette.grey[100],
    borderRadius: '8px',
    margin: theme.spacing(0.5),
    flex: 1,
  },
  detailLabel: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    color: theme.palette.grey[600],
    textWrap: 'nowrap',
  },
  detailValue: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
    marginTop: theme.spacing(0.5),
    background: '#193C763B',
    padding: theme.spacing(0.6),
    borderRadius: '8px',
    minWidth: '60px',
    textWrap: 'nowrap',
  },
})

const ProfileCard = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card elevation={0}>
      <CardActionArea className={classes?.card} onClick={onClick}>
        <div className={classes?.header}>
          <img src={MedunitedBadge} alt='MedUnited' />
        </div>
        <Box display='flex' flexDirection='column' alignItems='center'>
          <Badge
            overlap='circular'
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            variant='dot'
            className={classes?.badge}
          >
            <Avatar
              src={`https://i.pravatar.cc/150?img=${Math.random()}`}
              alt='Profile Picture'
              className={classes?.avatar}
            />
          </Badge>
          <Typography className={classes?.name}>Joel Mihavel</Typography>
          <Typography className={classes?.contact}>
            Contact:{' '}
            <Box
              component={'span'}
              fontWeight={500}
              color={theme.palette.text.primary}
            >
              7999838226
            </Box>
          </Typography>
        </Box>
        <CardContent>
          <Grid container spacing={2} justifyContent='center'>
            {[
              { label: 'MRN No.', value: '385989' },
              { label: 'ABA ID.', value: '989898' },
              { label: 'Days Left', value: '9 Days' },
              { label: 'Members', value: '4' },
            ].map((detail, index) => (
              <Grid size={{ xs: 6 }} key={index}>
                <div className={classes?.detailBox}>
                  <Typography className={classes?.detailLabel}>
                    {detail.label}
                  </Typography>
                  <Typography className={classes?.detailValue}>
                    {detail.value}
                  </Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default ProfileCard
